import { render, staticRenderFns } from "./MenuItemsSelectField.vue?vue&type=template&id=42db3954&scoped=true&"
import script from "./MenuItemsSelectField.vue?vue&type=script&lang=js&"
export * from "./MenuItemsSelectField.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemsSelectField.vue?vue&type=style&index=0&id=42db3954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db3954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VListItem,VListItemContent,VSelect,VTextField})
